import { useEffect, useState } from "react";
import type { ExistingRecord } from "../checkin-context";
import { Cause } from "../../../types/models";

type UseCheckInSavedCausesParams = {
  existingRecord: ExistingRecord | null | undefined;
  initialFromState: unknown;
  getCausesForMood: (moodId: string) => unknown[];
  enrichCausesWithTranslations: (
    specs: unknown[],
    useAllCauseTypes: boolean
  ) => unknown[];
};

export function useCheckInSavedCauses({
  existingRecord,
  initialFromState,
  getCausesForMood,
  enrichCausesWithTranslations,
}: UseCheckInSavedCausesParams) {
  const [savedCauses, setSavedCauses] = useState<Cause[]>(
    () => initialFromState as Cause[]
  );

  useEffect(() => {
    if (
      existingRecord?.id &&
      (savedCauses === null || savedCauses === undefined)
    ) {
      const filteredSpecs = getCausesForMood(existingRecord.id);
      const filteredSpecsWithTranslation = enrichCausesWithTranslations(
        filteredSpecs,
        true
      );
      setSavedCauses(filteredSpecsWithTranslation as Cause[]);
    }
  }, [
    existingRecord?.id,
    savedCauses,
    getCausesForMood,
    enrichCausesWithTranslations,
  ]);

  return { savedCauses, setSavedCauses };
}
